import { Action } from "@ngrx/store";
import { KpiChartConfigurationDto, KpiBaseChartDto } from "../../services/chart/kpi-chart.service";

// Load Charts
export const LOAD_CHARTS = "[Charts] Load Charts";
export const LOAD_CHARTS_SUCCESS = "[Charts] Load Charts Success";
export const LOAD_CHARTS_FAIL = "[Charts] Load Charts Fail";

export class LoadCharts implements Action {
  readonly type = LOAD_CHARTS;
}

export class LoadChartsSuccess implements Action {
  readonly type = LOAD_CHARTS_SUCCESS;
  constructor(public payload: KpiBaseChartDto[]) {}
}

export class LoadChartsFail implements Action {
  readonly type = LOAD_CHARTS_FAIL;
  constructor(public payload: any) {}
}

// Load Static Chart
export const LOAD_STATIC_CHART = "[Charts] Load Static Chart";
export const LOAD_STATIC_CHART_SUCCESS = "[Charts] Load Static Chart Success";
export const LOAD_STATIC_CHART_FAIL = "[Charts] Load Static Chart Fail";

export class LoadStaticChart implements Action {
  readonly type = LOAD_STATIC_CHART;
  constructor(public id: string, public frequency: string) {}
}

export class LoadStaticChartSuccess implements Action {
  readonly type = LOAD_STATIC_CHART_SUCCESS;
  constructor(public payload: KpiBaseChartDto) {}
}

export class LoadStaticChartFail implements Action {
  readonly type = LOAD_STATIC_CHART_FAIL;
  constructor(public payload: any) {}
}

// Create Chart
export const CREATE_CHART = "[Charts] Create Chart";
export const CREATE_CHART_SUCCESS = "[Charts] Create Chart Success";
export const CREATE_CHART_FAIL = "[Charts] Create Chart Fail";

export class CreateChart implements Action {
  readonly type = CREATE_CHART;
  constructor(public payload: KpiChartConfigurationDto) {}
}

export class CreateChartSuccess implements Action {
  readonly type = CREATE_CHART_SUCCESS;
  constructor(public payload: KpiBaseChartDto) {}
}

export class CreateChartFail implements Action {
  readonly type = CREATE_CHART_FAIL;
  constructor(public payload: any) {}
}

// Update Chart
export const UPDATE_CHART = "[Charts] Update Chart";
export const UPDATE_CHART_SUCCESS = "[Charts] Update Chart Success";
export const UPDATE_CHART_FAIL = "[Charts] Update Chart Fail";

export class UpdateChart implements Action {
  readonly type = UPDATE_CHART;
  constructor(public id: string, public payload: KpiChartConfigurationDto) {}
}

export class UpdateChartSuccess implements Action {
  readonly type = UPDATE_CHART_SUCCESS;
  constructor(public payload: KpiBaseChartDto) {}
}

export class UpdateChartFail implements Action {
  readonly type = UPDATE_CHART_FAIL;
  constructor(public payload: any) {}
}

// Delete Chart
export const DELETE_CHART = "[Charts] Delete Chart";
export const DELETE_CHART_SUCCESS = "[Charts] Delete Chart Success";
export const DELETE_CHART_FAIL = "[Charts] Delete Chart Fail";

export class DeleteChart implements Action {
  readonly type = DELETE_CHART;
  constructor(public id: string, public endpointUrl: string) {}
}

export class DeleteChartSuccess implements Action {
  readonly type = DELETE_CHART_SUCCESS;
  constructor(public id: string) {}
}

export class DeleteChartFail implements Action {
  readonly type = DELETE_CHART_FAIL;
  constructor(public payload: any) {}
}

// Reorder Charts
export const REORDER_CHARTS = "[Charts] Reorder Charts";
export const REORDER_CHARTS_SUCCESS = "[Charts] Reorder Charts Success";
export const REORDER_CHARTS_FAIL = "[Charts] Reorder Charts Fail";

export class ReorderCharts implements Action {
  readonly type = REORDER_CHARTS;
  constructor(public payload: KpiBaseChartDto[]) {}
}

export class ReorderChartsSuccess implements Action {
  readonly type = REORDER_CHARTS_SUCCESS;
  constructor(public payload: KpiBaseChartDto[]) {}
}

export class ReorderChartsFail implements Action {
  readonly type = REORDER_CHARTS_FAIL;
  constructor(public payload: any) {}
}

export type ChartsActions =
  | LoadCharts
  | LoadChartsSuccess
  | LoadChartsFail
  | CreateChart
  | CreateChartSuccess
  | CreateChartFail
  | UpdateChart
  | UpdateChartSuccess
  | UpdateChartFail
  | DeleteChart
  | DeleteChartSuccess
  | DeleteChartFail
  | ReorderCharts
  | ReorderChartsSuccess
  | ReorderChartsFail
  | LoadStaticChart
  | LoadStaticChartSuccess
  | LoadStaticChartFail;
